export enum ActionsPathsEnum {
  newRequestPage = '/actions',
  newEarlyTerminationRequest = '/actions/new/early-termination',
  earlyTerminationRequestSuccess = '/actions/new/early-termination/success',
}
